import SimpleAlert from "./SimpleAlert.vue";

var Plugin = {
  install(Vue: any, options: any) {
    Vue.component("SimpleAlert", SimpleAlert);
  }
};

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && (window as any).Vue) {
  (window as any).Vue.use(Plugin);
}

export default Plugin;